import { useEffect, useState } from 'react';
import { app } from "@microsoft/teams-js";
import { authentication } from "@microsoft/teams-js";
import { TeamsRoutes } from '../../routes/route.path';
import { MicrosoftIcon } from '../../../icon';
import { AuthService } from '../../../services/AuthService';
import setToast from '../../../helpers/toaster.helper';
import { ToasterTexts } from '../../shared/constants';
import { ToasterType } from '../../shared/toaster/toaster.model';
import { useNavigate } from 'react-router-dom';

const MicrosoftTeamsSSO = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const getClientSideToken = async () => {

    app.initialize()
    try {
      const token = await authentication.getAuthToken();
      AuthService.microSoftLogin(token, navigate)
      // console.log("token:", token)
    } catch (error) {
      setIsLoading(false)
      sessionStorage.setItem('isSSOLoginLoading', 'false')
      setToast(ToasterTexts.SOMETHING_WENT_WRONG_MESSAGE, ToasterType.DANGER)
      console.error("Initialization error:", error);
    }
  };

  const showConsentPopup = () => {
    sessionStorage.setItem('isSSOLoginLoading', 'true')
    setIsLoading(true)
    authentication.authenticate({
      url: TeamsRoutes.TEAMS_LOGIN_PAGE_SSO,
      width: 600,
      height: 535,
    })
      .then((result) => {
        getClientSideToken()
      })
      .catch((error) => {
        sessionStorage.setItem('isSSOLoginLoading', 'false')
        setIsLoading(false)
        console.log("error:", error)
      })
  };

  useEffect(() => {
    setIsLoading(AuthService.isSSOLoginLoading())
  }, [AuthService.isSSOLoginLoading()])

  return (
    <button
      data-arrow-index={9}
      data-up-arrow-index={8}
      data-down-arrow-index={9}
      data-left-arrow-index={2}
      data-right-arrow-index={9}
      tabIndex={4}
      onClick={showConsentPopup}
      disabled={isLoading}
      className={`c-pointer justify-center  d-flex h4-regular w-fill px-5 br-2 ${isLoading ? 'disabled disabled-btn' : 'secondary-btn'}`}>
      {isLoading ? <span className="mr-1 loader-secondary my-auto"></span> : <MicrosoftIcon />}
      <span className={"my-auto ml-1"}>{"Log in with Microsoft"}</span>
    </button>
  );
};

export default MicrosoftTeamsSSO;
